export default __webpack_public_path__ + "static/media/newple-logo-rect-rad-with-name-1.1de8b38f.svg";